import { useCallback, useRef } from 'react';
import { useUpdateTaskMutation } from 'shared/hooks/queries/use-update-task-mutation';
import { UpdateTask } from 'shared/types/task';

export const useUpdateTask = () => {
  const updateTaskRef = useRef<UpdateTask>();
  const {
    mutate: updateTask,
    error,
    isPending,
    isSuccess,
    reset,
  } = useUpdateTaskMutation();

  const submit = useCallback(
    (task: UpdateTask) => {
      updateTaskRef.current = task;

      updateTask(task);
    },
    [updateTask],
  );

  const retry = useCallback(() => {
    const task = updateTaskRef.current;

    if (task) {
      updateTask(task);
    }
  }, [updateTask]);

  const resetAll = useCallback(() => {
    reset();
    updateTaskRef.current = undefined;
  }, [reset]);

  return {
    submit,
    retry,
    reset: resetAll,
    error,
    isLoading: isPending,
    isSuccess,
  };
};
